import { DroneEntity, DroneStatusType } from '@src/core/features';

/**
 * When GET /drone returns duplicate rows (IDLE + MISSION) for one serial, prefer the
 * non-idle row so map, Go Here, and Redux selection stay aligned with live flight.
 */
export function findDroneBySerial(
  serial: string,
  missionDrones: DroneEntity[],
  idleDrones: DroneEntity[],
  allDrones: DroneEntity[]
): DroneEntity | undefined {
  const missionRow = missionDrones.find((d) => d.serialNumber === serial);
  const idleRow = idleDrones.find((d) => d.serialNumber === serial);

  if (missionRow && idleRow) {
    return missionRow.status !== DroneStatusType.IDLE ? missionRow : idleRow;
  }

  return missionRow ?? idleRow ?? allDrones.find((d) => d.serialNumber === serial);
}

export function isSerialInMissionBucket(
  serial: string | null | undefined,
  missionDrones: DroneEntity[]
): boolean {
  if (!serial) return false;
  return missionDrones.some((d) => d.serialNumber === serial);
}
